import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppNotifyService } from '../../../../core/services/app-notify.service';
import { CommonService } from '../../../../core/services/common.service';
import { LanguageTranslationService } from '../../../../core/services/language-translation.service';
import { StatePersistingService } from '../../../../core/services/state-persisting.service';
import { UserService } from '../../../../core/services/user.service';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { GridSettings } from '../../../../core/common';
import { IGetOrdersInquiryBody, IOrderInquiry, IOrderInquiryLbl } from '../../../../core/models';
import { DataStateChangeEvent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { OrderService } from '../../../../core/services/order.service';
import { FreightClaimService } from '../../../../core/services/freight-claim.service';
import { NotifyType } from '../../../../core/enums/NotifyType';

@Component({
  selector: 'app-order-selection',
  templateUrl: './order-selection.component.html',
  styleUrls: ['./order-selection.component.scss']
})
export class OrderSelectionComponent implements OnInit {
  public gridData: IOrderInquiry[] = [];
  dayInPastOrderWouldShow: number = 100;
  toDate: Date = new Date();
  fromDate: Date = new Date(this.toDate.getFullYear(), this.toDate.getMonth(), this.toDate.getDay() - this.dayInPastOrderWouldShow);//last 30 days
  orderSelectionGridData: GridDataResult;
  loadingPDF: boolean = false;
  loadingExcel: boolean = false;
  orderLoading: boolean = false;
  loadingOrder: boolean = false;
  constructor(
    private orderService: OrderService,
    private freightClaimService: FreightClaimService,
    private commonService: CommonService,
    private persistingService: StatePersistingService,
    private languageTranslationService: LanguageTranslationService,
    private router: Router,
    private userService: UserService,
    private appNotifyService: AppNotifyService,) {
    //console.log('c1', this.orderGridstate.filter);
    //this.initScreen();
  }

  ngOnInit() {    
    this.initScreen();
    this.fillOrderGrid(this.fromDate, this.toDate);
  }
  public setDateRange() {
    this.toDate = new Date();
    this.fromDate = new Date(this.toDate.getFullYear(), this.toDate.getMonth(), this.toDate.getDay() - this.dayInPastOrderWouldShow);
    this.orderGridstate.filter.filters = [{
      field: "scheduleDateAsDate", operator: "gte", value: this.fromDate
    }, {
      field: "scheduleDateAsDate", operator: "lte", value: this.toDate
    }];

    //console.log('c2', this.orderGridstate.filter);
    this.loadOrderGridData();
  }
  public initScreen(): void {
    this.freightClaimService.getInitData().subscribe((response: any) => {
      this.dayInPastOrderWouldShow = response.noOfDaysForRasisingClaim;
      this.setDateRange();
    },
      (error) => { console.log(error); }
    );
  }

  //#region Grid Data Load
  public fillOrderGrid(fromDate: Date, toDate: Date): void {
    this.loadingOrder = true;
    const body: IGetOrdersInquiryBody = {
      customerNumber: '',
      fromDate: fromDate,
      toDate: toDate
    }
    this.freightClaimService.getOrders(body).subscribe((response: Array<IOrderInquiry>) => {
      this.gridData = response.map((obj) => {
        obj.orderDateAsDate = obj.orderDateUIString ? new Date(obj.orderDateUIString) : null;
        obj.scheduleDateAsDate = obj.scheduleDateUIString == "Pending" ? null : new Date(obj.scheduleDateUIString);
        return obj;
      },
        (error) => {
          this.appNotifyService.notify(NotifyType.ERROR, "Sorry! There was an error loading the screen. Please refresh the screen and try again!");
          this.loadingOrder = false;
        }
      );
      this.loadOrderGridData();
      this.loadingOrder = false;;

    })
  }

  public loadOrderGridData(): void {
    // Step 1: Filter out rows where scheduleDateUIString = "Pending"
    const filteredData = this.gridData.filter(order =>
      order.scheduleDateUIString.toLowerCase() !== 'pending'
    );
    // Step 2: Process grid data with state
    if (this.gridSettings.state) {
      this.orderSelectionGridData = process(filteredData, this.gridSettings.state);
    }
    else {
      this.orderSelectionGridData = process(filteredData, this.orderGridstate);
    }
    // Step 3: Assign processed data back to grid
    this.gridSettings.gridData = this.orderSelectionGridData;
  }

  //#endregion

  //#region label declaration
  public orderlblText: IOrderInquiryLbl = {
    jobNamelbl: 'Job Name',
    jobNumberlbl: 'Job Number',
    kdReflbl: 'KD Ref#',
    orderDatelbl: 'Order Date',
    orderTypeLbl: 'Order Type',
    orderNumberlbl: 'Order #',
    polbl: 'PO #',
    scheduleDatelbl: 'Schedule Date',
    shipFromlbl: 'Ship From',
    shipTolbl: 'Shipt To',
    exportToExcelLbl: 'Export To Excel',
    exportToPDFLbl: 'Export To PDF',
    customerNumberLbl: 'Customer Number',
    customerNameLbl: 'Customer Name',
  }
  public orderSelectionGridLbl = {
    orderNumberlbl: 'Order #',
    orderTypeLbl: 'Order Type',
    orderDatelbl: 'Order Date',
    scheduleDatelbl: 'Schedule Date',
    jobNamelbl: 'Job Name',
    jobNumberlbl: 'Job Number',
    kdReflbl: 'KD Ref#',
    polbl: 'PO #',
    shipFromlbl: 'Ship From',
    exportToExcelLbl: 'Export To Excel',
    exportToPDFLbl: 'Export To PDF',
    customerNumberLbl: 'Customer Number',
    customerNameLbl: 'Customer Name',

  };
  //#endregion

  //#region pagination, sorting,filtering for order grid
  public orderGridstate: State = {
    skip: 0,
    take: 20,
    sort: [{ field: 'orderNumber', dir: 'desc' }],
    filter: { logic: 'and', filters: [] } // start with no filters
  };

  // Apply filter only if dates are selected
  applyDateFilter(): void {
    const filters: any[] = [];

    if (this.fromDate) {
      filters.push({
        field: 'scheduleDateAsDate',
        operator: 'gte',
        value: this.fromDate
      });
    }

    if (this.toDate) {
      filters.push({
        field: 'scheduleDateAsDate',
        operator: 'lte',
        value: this.toDate
      });
    }

    this.orderGridstate = {
      ...this.orderGridstate,
      filter: {
        logic: 'and',
        filters
      }
    };

    this.loadOrderGridData();  // reload grid after applying filter
  }

  // Clear filters completely and reload
  clearFilters(): void {
    this.fromDate = null;
    this.toDate = null;

    this.orderGridstate = {
      ...this.orderGridstate,
      filter: { logic: 'and', filters: [] }
    };

    this.loadOrderGridData(); // reload grid after clearing filter
  }

  public gridSettings: GridSettings = {
    state: this.orderGridstate,
    gridData: process(this.gridData, this.orderGridstate),
    columnsConfig: [{
      field: 'orderNumber',
      title: this.orderlblText.orderNumberlbl ? this.orderlblText.orderNumberlbl : this.orderSelectionGridLbl.orderNumberlbl,
      filterable: true

    }, {
      field: 'orderType',
      title: this.orderlblText.orderTypeLbl ? this.orderlblText.orderTypeLbl : this.orderSelectionGridLbl.orderTypeLbl,
      filterable: true
    }, {
      field: 'orderDateAsDate',
      title: this.orderlblText.orderDatelbl ? this.orderlblText.orderDatelbl : this.orderSelectionGridLbl.orderDatelbl,
      filter: 'date',
      format: '{0:d}',//not able to get from and to
      _width: 240,
      filterable: false
    }, {
      field: 'scheduleDateUIString',//'scheduleDateAsDate',
      title: this.orderlblText.scheduleDatelbl ? this.orderlblText.scheduleDatelbl : this.orderSelectionGridLbl.scheduleDatelbl,
      filter: 'date',
      format: '{0:d}',
      _width: 240,
      filterable: false
    }, {
      field: 'jobName',
      title: this.orderlblText.jobNamelbl ? this.orderlblText.jobNamelbl : this.orderSelectionGridLbl.jobNamelbl,
      filterable: true
    }, {
      field: 'jobNumber',
      title: this.orderlblText.jobNumberlbl ? this.orderlblText.jobNumberlbl : this.orderSelectionGridLbl.jobNumberlbl,
      filterable: true
    }, {
      field: 'poNumber',
      title: this.orderlblText.polbl ? this.orderlblText.polbl : this.orderSelectionGridLbl.polbl,
      filterable: true
    },
    {
      field: 'shipFrom',
      title: this.orderlblText.shipFromlbl ? this.orderlblText.shipFromlbl : this.orderSelectionGridLbl.shipFromlbl,
      filterable: true
    },
    {
      field: 'kdReference',
      title: this.orderlblText.kdReflbl ? this.orderlblText.kdReflbl : this.orderSelectionGridLbl.kdReflbl,
      filterable: true
    }
    ]
  };

  public orderGridSortChange(sort): void {
    this.orderGridstate.sort = sort;
    this.loadOrderGridData();
  }

  public orderGridPageChange({ skip, take }: PageChangeEvent): void {
    this.orderGridstate.skip = skip;
    this.orderGridstate.take;
    this.loadOrderGridData();
  }
  public orderDataStateChange(state: DataStateChangeEvent): void {
    this.orderGridstate = state;
    this.gridSettings.state = this.orderGridstate;
    this.loadOrderGridData();
  }
  //#endregion

  //#region Export
  generateExcel() { }
  generatePDF() { }
  //#endregion

  proceedToClaimSubmissionScreen(order) {
    this.freightClaimService.selectedOrder = order;
    this.router.navigate(['/self-service/order-selection/raise-claim']);
  }
}
